import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Studio from "@/pages/Studio";
import { LanguageProvider } from "@/i18n";
import { AuthProvider, ProtectedRoute } from "@/admin/AuthContext";
import AdminLayout from "@/admin/AdminLayout";
import Login from "@/admin/Login";
import ContentManager, { Dashboard, MediaLibrary, Users } from "@/admin/ContentManager";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Studio />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="pages" element={<ContentManager type="pages" />} />
              <Route path="products" element={<ContentManager type="products" />} />
              <Route path="blog" element={<ContentManager type="blog" />} />
              <Route path="media" element={<MediaLibrary />} />
              <Route path="users" element={<ProtectedRoute roles={["admin"]}><Users /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Studio />} />
          </Routes>
        </BrowserRouter>
    </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
